import { withRouter } from 'react-router';
import {
  compose,
  withState,
  withProps,
  branch,
  renderComponent,
  renderNothing,
  withPropsOnChange,
} from 'recompose';

import Loader from '../../components/Loader';
import withExtensionContextConsumer from './withExtensionContextConsumer';
import { getBrandRewardProgram, getCustomerReward } from '../../reservation/actions';

export default compose(
  withRouter,
  withState('busy', 'setBusy', true),
  withState('rewardProgram', 'setRewardProgram', null),
  withState('customerReward', 'setCustomerReward', null),
  withExtensionContextConsumer,
  withPropsOnChange(
    ['extension'],
    async (props) => {
      if (!props.extension) {
        props.setBusy(false);
        return;
      }

      const promises = [getBrandRewardProgram(props.extension.brandId)];
      if (props.params.customerRewardId) {
        promises.push(getCustomerReward(props.params.customerRewardId));
      }

      try {
        const [rewardProgram, customerReward] = await Promise.all(promises);
        props.setRewardProgram(rewardProgram);
        if (customerReward) {
          props.setCustomerReward(customerReward);
        }
      } finally {
        props.setBusy(false);
      }
    }
  ),
  branch(
    props => props.busy,
    renderComponent(Loader),
  ),
  branch(
    (props) => {
      const shouldWaitForCustomerReward = !!props.params.customerRewardId;
      return !props.rewardProgram && (!shouldWaitForCustomerReward || props.customerReward);
    },
    renderNothing,
  ),
  withProps(({ rewardProgram, customerReward }) => (
    {
      isAmountBased: rewardProgram.rewardType === 'value',
      loyaltyAmountGoal: rewardProgram.goalCounter,
      loyaltyTransactionsGoal: rewardProgram.numberOfTransactions,
      loyaltyAmount: rewardProgram.rewardAmount,
      loyaltyProgress: 50, // it's hardcoded for now
      loyaltyCode: customerReward ? customerReward.customerPromo.promo.code : null,
    }
  )),
);



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withLoyaltyNotification.js